import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Annuncio } from 'src/app/models/annuncio';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit-annuncio',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditAnnuncioComponent extends BaseEditForm implements OnInit {

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditAnnuncioComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Annuncio,
  ) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group({
      titolo: [this.data?.titolo, Validators.required],
      contenuto: [this.data?.contenuto, Validators.required],
    });
  }
}
